import { PropTypes } from '../dependencies';

export const restaurantShape = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    menu: PropTypes.shape(/* TODO menu shape */),
    isFavourite: PropTypes.bool.isRequired,
};

export const restaurantWithSelectedShape = {
    ...restaurantShape,
    isSelected: PropTypes.bool.isRequired,
    hasParser: PropTypes.bool.isRequired,
};
